import { types, getRoot, applySnapshot } from 'mobx-state-tree';
import ProductList from './ProductList';
import OrderProperty from './OrderProperty';
import SplitOrderAction from './SplitOrderAction';
import SplitOrder from './SplitOrder';
import axios from 'axios';
import Address from './Address';
import ShippingMethod from './ShippingMethod';
import PaymentMethod from './PaymentMethod';
import ShippingCountry from './ShippingCountry';


export default types.model('Order', {
    UpdatedByConnectionId: types.maybeNull(types.string, ""),
    TimeStamp: types.optional(types.number, 0),
    OrderGuid: types.identifier,
    OrderNumber: types.maybeNull(types.string),
    OrderStatusId: types.optional(types.number, 0),
    AllowOrdering: types.optional(types.boolean, false),

    Note: types.optional(types.string, ""),
    BillingAddress: types.maybeNull(Address),
    ShippingAddress: types.maybeNull(Address),
    ShippingAddressName: types.maybeNull(types.string),
    ProductList: types.optional(types.array(ProductList), []),

    ShippingMethods: types.optional(types.array(ShippingMethod), []),
    ShippingMethodId: types.optional(types.number, 0),
    PaymentMethods: types.optional(types.array(PaymentMethod), []),
    PaymentMethodId: types.optional(types.number, 0),
    ShippingCountries: types.optional(types.array(ShippingCountry), []),
    OrderProperties: types.optional(types.array(OrderProperty), []),
    SubTotalFormatted: types.optional(types.string, ""),
    SubTotalWithVATFormatted: types.optional(types.string, ""),
    
    ShippingTotal: types.optional(types.number, 0),
    ShippingTotalFormatted: types.optional(types.string, ""),
    ShippingTotalExTax: types.optional(types.number, 0),
    ShippingTotalExTaxFormatted: types.optional(types.string, ""),
    
    ShipmentPrice: types.optional(types.number, 0),
    ShipmentPriceFormatted: types.optional(types.string, ""),

    OrderTotal: types.optional(types.number, 0),
    OrderTotalFormatted: types.optional(types.string, ""),
    DiscountTotalFormatted: types.optional(types.string, ""),
    DiscountTotalWithVATFormatted: types.optional(types.string, ""),
    FreeShippingInfo: types.maybeNull(types.string, ""),
    Vouchers: types.optional(types.array(types.string), []),
    OrderArticleCount: types.optional(types.number, 0),
    OrderArticleCountNA: types.optional(types.number, 0),
    RowsCount: types.optional(types.number, 0),
    RowsCountNA: types.optional(types.number, 0),

    VAT: types.optional(types.number, 0),
    VATFormatted: types.optional(types.string, ""),

    TaxTotal: types.optional(types.number, 0),
    TaxTotalFormatted: types.optional(types.string, ""),

    SplitOrderActions: types.optional(types.array(SplitOrderAction), []),
    SplitOrders: types.optional(types.array(SplitOrder), []),
    ProductsInStock: types.optional(types.number, 0),
    Updating: types.optional(types.boolean, false),
     
    CheckoutStarted: types.optional(types.boolean, false),
    CheckoutTimeoutSecondsLeft: types.optional(types.number, 0),
    CheckoutUser: types.optional(types.number, 0),
    Currency: types.optional(types.string,""),
    CurrencyCode: types.optional(types.string,""),
    AdditionalData: types.optional(types.frozen(), {})



}).views(self => ({

    get navigation() {
        return getRoot(self).navigation;
    },

    get orderStore() {
        return getRoot(self).order;
    },

    get account() {
        return getRoot(self).account;
    },

    get analytics() {
        return getRoot(self).analytics;
    },


    OrderPropertyByKey(key) {
        const p = self.OrderProperties.find(op => op.Key === key);

        const value = p && p.Value;
        //console.debug("OrderPropertyByKey updated:", key, "Value: ", value);
        if (value) {
            return value;
        } else {
            return null;
        }
    },



    get DeliveryDate() {
        return self.OrderPropertyByKey("DeliveryDate");
    },


    get OrderWarehouseStart() {
        return self.OrderPropertyByKey("_OrderWarehouseDateStart");
    },

    get OrderWarehouseEnd() {
        return self.OrderPropertyByKey("_OrderWarehouseDateEnd");
    },

    get OrderType() {
        return self.OrderPropertyByKey("OrderType");
    },

    get OrderTemplateName() {
        const p = self.OrderProperties.find(op => op.Key === "_OrderTemplateName");
        if (p && p.Value) {
            return p.Value;
        } else {
            return null;
        }
    },

    get SplitOrderAction() {
        return self.OrderPropertyByKey("SplitOrderAction");
    },

    get Reference() {
        return self.OrderPropertyByKey("Reference") || "";
    },


    get Valid() {
        // todo: improve this
        return self.OrderStatusId === 1 && self.AllowOrdering === true;
    },

    get HasShippingAddress() {
        return self.ShippingAddressName !== null && self.ShippingAddressName !== "";
    },
    
    get HasPaymentMethod() {
        return self.PaymentMethodId !== 0;
    },


    get Readonly() {
        return self.OrderStatusId > 1 || self.CheckoutStarted && self.CheckoutUser !== self.account.UserId;
    },

    get OrderStatus() {
        switch (self.OrderStatusId) {

            case 0:
                return "";
            case 1:
                return "Basket";
            default:

                return "Submitted";

        }
    },

    OrderLineById(id) {
        for (const list of self.ProductList) {
            const item = list.OrderLines.find(x => x.OrderLineId === id);
            if (item) {
                return item;
            }
        }
        return null;
    },

    OrderLinesBySku(sku, variantSku) {
        return self.ProductList.map(list => list.OrderLines.filter(x => x.Sku === sku && x.VariantSku === variantSku))
            .reduce((a, b) => a.concat(b), []);
    },
    

    
    ProductListGroupByKey(key) {
        return self.ProductList.find(x=>x.GroupKey === key);
    }






})).actions(self => ({

    SetUpdateInProgress() {
        self.Updating = true;
    },

    updateOrderProperty(key, value) {
        const p = self.OrderProperties.find(op => op.Key === key);
        if (p) {
            p.Value = value;
        } else {
            self.OrderProperties.push({OrderPropertyId: "", Key: key, Value: "" + value });
        }
   },

    toggleProductLineEdit(sku) {
        //		console.debug("setProductLineEdit", sku);
        const productLine = self.ProductList.find(product => product.Sku === sku);
        productLine.Edit = !productLine.Edit;
    },



    // async updateQuantities(changes, options = null) {
    //
    //     //self.Updating = true;
    //     const recalcPayment = self.navigation.TemplateAlias === "IComCheckout";
    //
    //   
    //     changes.forEach(change => {
    //
    //         let orderLine = self.OrderLineById(change.OrderLineId);
    //         if (!orderLine) {
    //             const orderLinesBySku = self.OrderLinesBySku(change.Sku, change.VariantSku);
    //             if (orderLinesBySku && orderLinesBySku.length > 0) {
    //                 orderLine = orderLinesBySku[0];
    //             }
    //         }
    //            
    //
    //
    //         let parsedNumber = Number.parseInt(change.OriginalQuantity);
    //
    //         if (orderLine) {
    //             if (Number.isNaN(parsedNumber)) {
    //                 parsedNumber = 0;
    //             }
    //             orderLine.SetOriginalQuantity(parsedNumber);
    //             orderLine.Quantity = parsedNumber;
    //         } else {
    //            
    //         }
    //
    //         change.Quantity = change.OriginalQuantity;
    //
    //     });
    //
    //     const updateQuantitiesOptions = options && { Import: options.import, Commit: options.commit };
    //
    //     //[{sku:'1234',quantity:5},{}..]
    //     const res = await self.request("/Umbraco/Api/ActorOrder/UpdateQuantities",
    //         {
    //             OrderGuid: self.OrderGuid,
    //             changes: changes,
    //             SiteId: self.navigation.SiteId,
    //             CultureCode: self.navigation.CultureCode,
    //             MarketCode: self.navigation.MarketCode,
    //             CountryCode: self.navigation.CountryCode,
    //             RecalcPayment: recalcPayment, // checkoutTemplate open ?
    //             BasketRequest: self.orderStore.useBasket,
    //             CustomerId: self.navigation.getCustomerId(),
    //             ConnectionId: self.connection ? self.connection.id : null,
    //             Options: updateQuantitiesOptions
    //         });
    //
    //     if (res.status && res.status === "error") {
    //         throw res;
    //     }
    //
    //     if (res && res.BasketGuid) {
    //         self.orderStore.setBasket(res);
    //         // Handle added products
    //         changes.forEach(change => {
    //             if (change.NewProduct) {
    //                 const productLine = self.Basket.ProductList.find(product => product.Sku === change.Sku);
    //                 const orderLine = productLine
    //                     ? change.VariantSku
    //                         ? productLine.OrderLines.find(x => x.VariantSku === change.VariantSku)
    //                         : productLine.OrderLines.find(x => x.Sku === change.Sku)
    //                     : null;
    //
    //                 if (orderLine) {
    //                     if (self.analytics) {
    //                         var addEvent = {
    //                             CurrencyCode: self.activeOrder.CurrencyCode,
    //                             ProductName: orderLine.ProductName,
    //                             VariantName: orderLine.VariantName,
    //                             Sku: orderLine.Sku,
    //                             VariantSku: orderLine.VariantSku,
    //                             Quantity: Math.abs(change.AddQuantity),
    //                             PriceFloatingPoint: orderLine.Price + orderLine.VAT
    //                         }
    //                         if (change.AddQuantity < 0) {
    //                             self.analytics.removeFromCart(addEvent);
    //                         } else if (change.AddQuantity > 0) {
    //                             self.analytics.addToCart(addEvent);
    //                         }
    //                     }
    //                 }
    //             }
    //         });
    //     }
    //
    //     return res;
    // },




    async removeProduct(sku) {
        const res = await self.request("/Umbraco/Api/ActorOrder/RemoveProduct",
            {
                OrderGuid: self.OrderGuid,
                CustomerId: self.navigation.getCustomerId(),
                CultureCode: self.navigation.CultureCode,
                Sku: sku
            });
        // res is a Promise
        //applySnapshot(self, res);
    },



    async setReference(value) {
        console.log("setReference", value);
        self.updateOrderProperty("Reference", value);
    },

    async setNote(value) {
        self.Note = value;
    },

    async setDeliveryDate(value) {
        console.debug("setDeliveryDate", value);
        self.updateOrderProperty("DeliveryDate", value);
        await self.update();
    },

    async updateShippingAddress(changes) {
        //debugger;
        // const res = await self.request("/Umbraco/Api/ActorOrder/Update",
        //     {
        //         SiteId: self.navigation.mainTree.Id,
        //         CustomerId: self.navigation.getCustomerId(),
        //         CultureCode: self.navigation.CultureCode,
        //         OrderGuid: self.OrderGuid,
        //         ShippingAddress: changes.shippingAddress
        //     });
        //
        // applySnapshot(self, res);
        
        self.update(changes);
        
    },

    async setShippingAddressName(addressName) {
        self.ShippingAddressName = addressName;
        await self.update();
    },
    
    async setShippingMethod(shippingMethodId)    {
        self.ShippingMethodId = shippingMethodId;
        await self.update();
    },

    async setPaymentMethod(paymentMethodId)    {
        self.PaymentMethodId = paymentMethodId;
        await self.update();
    },

    async setSplitOrderAction(action) {
        self.updateOrderProperty("SplitOrderAction", action);
        await self.update();
    },

    async setOrderTemplate(orderTemplate) {
        self.updateOrderProperty("_OrderTemplateName", orderTemplate);
        await self.update();
    },


    async update(values) {
        const res = await self.request("/Umbraco/Api/ActorOrder/Update",
            {
                SiteId: self.navigation.mainTree.Id,
                CustomerId: self.navigation.getCustomerId(),
                CultureCode: self.navigation.CultureCode,
                CountryCode: self.navigation.CountryCode,
                OrderGuid: self.OrderGuid,
                ConnectionId: self.orderStore.connection ? self.orderStore.connection.id : null,

                Parameters: {
                    Reference: self.Reference,
                    Note: self.Note,
                    OrderProperties: self.OrderProperties,
                    ShippingAddress: values && values.shippingAddress || null,
                    ShippingAddressName: self.ShippingAddressName,
                    //PaymentMethodId: values.paymentMethod ? values.paymentMethod.PaymentMethodId : null,
                    ShippingMethodId: self.ShippingMethodId ? self.ShippingMethodId : null,
                    PaymentMethodId: self.PaymentMethodId ? self.PaymentMethodId : null,
                    OrderTemplateName: self.OrderTemplateName
                }
            });


        
        if (self.orderStore.useBasket && res && res.BasketGuid) {
            self.orderStore.setBasket(res);
        }

        applySnapshot(self, res);

    },


    async checkoutStart() {
        var res = await self.request("/Umbraco/Api/ActorOrder/CheckoutStart",
            {
                SiteId: self.navigation.mainTree.Id,
                CultureCode: self.navigation.CultureCode,
                CustomerId: self.navigation.getCustomerId(),
    
                OrderGuid: self.OrderGuid
            });

        if (res.status && res.status === "error") {
            throw res;
        }

        applySnapshot(self, res);

        console.debug("checkout started", self);
        
        if(self.analytics){
            self.analytics.checkout();
        }
        
    },


    async checkoutCancel() {
        var res = await self.request("/Umbraco/Api/ActorOrder/CheckoutCancel",
            {
                SiteId: self.navigation.mainTree.Id,
                CustomerId: self.navigation.getCustomerId(),
                CultureCode: self.navigation.CultureCode,
                OrderGuid: self.OrderGuid
            });

        if (res.status && res.status === "error") {
            throw res;
        }

        applySnapshot(self, res);

        console.debug("checkout cancelled", self);
    },

    async startBasketCheckout() {
        const res = await self.request("/Umbraco/Api/ActorOrder/HandleCheckout",
            {
                SiteId: self.navigation.mainTree.Id,
                CountryCode: self.navigation.CountryCode,
                CultureCode: self.navigation.CultureCode,
                MarketCode: self.navigation.MarketCode,
                CustomerId: self.navigation.CustomerId,
                BasketRequest: true,
                OrderGuid: self.OrderGuid

            });

        if (res.status && res.status === "error") {
            throw res;
        }
            
        //console.log("GetCheckout", res);
        if (res && res.BasketGuid) {
            self.orderStore.setBasket(res);
        }

        return res;

    },

    async AddVoucherCode(voucherCode) {
        const orderGuid = self.OrderGuid;
        const recalcPayment = self.navigation.TemplateAlias === "IComCheckout";

        const res = await self.request("/Umbraco/Api/ActorOrder/AddVoucher",
            {
                SiteId: self.navigation.SiteId,
                CultureCode: self.navigation.CultureCode,
                MarketCode: self.navigation.MarketCode,
                RecalcPayment: recalcPayment, // checkoutTemplate open ? 
                OrderGuid: orderGuid,
                CustomerId: self.navigation.CustomerId,
                ConnectionId: self.connection ? self.connection.id : null,
                BasketRequest: true,
                VoucherCode: voucherCode
            });

        if(res && res.errors){
            self.navigation.toastError("Rabattkupongen kunde inte hittas")
            return;
        }

        if (res && res.BasketGuid) { 
            self.orderStore.setBasket(res);
        }

        applySnapshot(self, res);
    },
    async RemoveVoucherCode(voucherCode) {
        const orderGuid = self.OrderGuid;
        const recalcPayment = self.navigation.TemplateAlias === "IComCheckout";

        const res = await self.request("/Umbraco/Api/ActorOrder/RemoveVoucher",
            {
                SiteId: self.navigation.SiteId,
                CultureCode: self.navigation.CultureCode,
                MarketCode: self.navigation.MarketCode,
                RecalcPayment: recalcPayment, // checkoutTemplate open ? 
                OrderGuid: orderGuid,
                BasketRequest: true,
                CustomerId: self.navigation.CustomerId,
                ConnectionId: self.connection ? self.connection.id : null,

                VoucherCode: voucherCode
            });


        if (res && res.BasketGuid) {
            self.orderStore.setBasket(res);
        }

        applySnapshot(self, res);
    },

    SetPropertyValueByKey(key, value) {
        const p = self.PropertyByKey(key);
        if (p) {
            p.Value = "" + value;
        } else {
            self.OrderProperties.push({ OrderPropertyId: "", Key: key, Value: "" + value });
        }
    },

    async checkout() {
        const res = await self.request("/Umbraco/Api/ActorOrder/CheckoutCommit",
            {
                SiteId: self.navigation.mainTree.Id,
                CultureCode: self.navigation.CultureCode,
                CustomerId: self.navigation.getCustomerId(),
                OrderGuid: self.OrderGuid
            });


        if (res.status && res.status === "error") {
            throw res;
        }

        if(self.analytics){
            self.analytics.purchase(res);
        }
        
        console.debug("Checked out", self);
        return res;
    },


    async request(path, query = {}) {
        const res = await axios.post(`${path}`, query);
        return res.data;
    }

}));
